<script>
import { groupColorLookup } from '../constants/RepGroupColors'

import ArrayUtil from '../utilities/ArrayUtil'

import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Tag } from 'buefy/dist/components/tag'
import { Switch } from 'buefy/dist/components/switch'
import { Radio, RadioButton } from 'buefy/dist/components/radio'

export default {
    name : "AddReportingGroupForm",
    props: {
        usedColors : Array
    },
    components: {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-tag' : Tag,
        'b-switch' : Switch,
        'b-radio' : Radio,
        'b-radio-button' : RadioButton
    },
    data(){
        return {
            newReportingGroupData : {
                name : "",
                tagName : "",
                repGroupTagClass : "",
                isActive : true
            },
            lovColors : [],
            globalError : {
                show : false,
                message : ""
            },
            errorFields : []
        }
    },
    created(){
        this.lovColors = [];
        if (this.usedColors.length > 0) {
            groupColorLookup.forEach(color=>{
                let res = this.usedColors.filter(uc=>{
                    return uc==color.value
                });
                if (res.length == 0) {
                    this.lovColors.push(color);
                }
            });
        }
    },
    methods : {
        closeError(){
            this.globalError.show = false;
            this.globalError.message = "";
        },
        showError(msg){
            this.globalError.show = true;
            this.globalError.message = msg;
        },
        hasError(field){
            return ArrayUtil.inArray(this.errorFields,field);
        },
        triggerClose(){
            this.newReportingGroupData.name = "";
            this.newReportingGroupData.isActive = true;
            this.newReportingGroupData.tagName = "";
            this.newReportingGroupData.repGroupTagClass = "";
            this.$emit('close');
        },
        triggerSubmit(){
            this.errorFields = [];
            if (this.newReportingGroupData.name.trim()=="") {
                this.errorFields.push('name');
            }
            if (this.newReportingGroupData.repGroupTagClass.trim()=="") {
                this.errorFields.push("repGroupTagClass");
            }
            if (this.newReportingGroupData.isActive==null) {
                this.errorFields.push("isActive");
            }
            if (this.errorFields.length > 0) {
                this.showError('Please check the mandatory fields.');
                return false;
            }
            this.$emit('submit-rep-group',this.newReportingGroupData)
        }
    }
}
</script>

<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title is-turquoise">New Reporting Group</p>
        </header>
        <section class="modal-card-body">

            <div class="has-text-left is-italic">
                Fields marked with * are mandatory.
            </div>

            <div class="notification is-danger"
                v-if="globalError.show">
                <button class="delete"
                    type="button"
                    v-on:click="closeError"></button>
                <p>{{globalError.message}}</p>
            </div>

            <div class="fields grouped">
                <b-field
                    label="*Name"
                    :type="{'is-danger':hasError('name')}">
                    <b-input 
                        v-model="newReportingGroupData.name"
                        type="text"
                        value=""
                        required></b-input>
                </b-field>
                <b-field
                    label="Tag"
                    message="If no tag name is provided, the system will automatically use the reporting group name.">
                    <b-input 
                        v-model="newReportingGroupData.tagName"
                        type="text"
                        value=""></b-input>
                </b-field>
                <b-field
                    label="*Color"
                    :type="{'is-danger':hasError('repGroupTagClass')}"
                    style="padding-bottom:1rem;">
                    <div class="columns is-mobile is-multiline"
                        style="padding-left:1rem;">
                        <div class="control column is-4 no-padd"
                            v-for="(color,colorIdx) in lovColors"
                            :key="colorIdx"
                            style="margin-top:0.3rem;">
                            <label class="radio has-text-left"
                                >
                                <input 
                                    type="radio" 
                                    name="group-color"
                                    v-model="newReportingGroupData.repGroupTagClass"
                                    :value="color.value">
                                <span 
                                    class="tag"
                                    :class="color.value">
                                    {{color.label}}
                                </span>
                            </label>
                        </div>
                    </div>
                </b-field>
                <b-field
                    label="*Active"
                    :type="{'is-danger':hasError('isActive')}">
                    <b-switch v-model="newReportingGroupData.isActive">
                        {{ newReportingGroupData.isActive==true ? "Yes" : "No" }}
                    </b-switch>
                </b-field>
            </div>
        </section>
        <footer class="modal-card-foot has-text-left">
            <a class="button is-white"
                v-on:click="triggerClose">
                <span>Cancel</span>
            </a>
            
            <a class="button is-success"
                v-on:click="triggerSubmit">
                <!-- v-bind:disabled="newReportingGroupData.name==''" -->
                <span>Submit</span>
            </a>
        </footer>
    </div>
</template>

<style scoped>
.selectable {
    cursor: pointer;
}
.color-selected {
    border:3px solid #209CEE;
}
</style>


// WEBPACK FOOTER //
// src/components/AddReportingGroupForm.vue